import punycode from 'punycode';

window.isEmailAvailableCache = typeof(window.isEmailAvailableCache) === 'undefined' ? {} : window.isEmailAvailableCache;

class EmailCheck {

    constructor(email, type) {
        this.email = email;
        this.type = type;
    }

    _getCacheKey() {
        return this.email;
    }

    _processResponse(callback, data, eventName) {
        // console.log(['check_username response', data]);
        window.debounceIsFetching = false;
        window.debounceCounter = window.debounceCounter-1;
        const { errorCode, flash: { type, text } } = data;
        //errorCode can be: USERNAME_NOT_AVAILABLE, BAD_DOMAIN, USERNAME_NOT_AVAILABLE, NO_USERNAME, NO_STRONG_CAPTCHA
        $('#not_available_captcha').hide();
        $('#not_available_default').show();
        if (type === 'success') {
            window.isEmailAvailableCache[this._getCacheKey()] = true;
            callback(true);
        } else {
            if (errorCode !== 'NO_STRONG_CAPTCHA') {
                window.isEmailAvailableCache[this._getCacheKey()] = false;
            }
            callback(false);
            if (errorCode === 'NO_STRONG_CAPTCHA') {
                $('#not_available_default').hide();
                $('#not_available_captcha').show();
            } else {
                $('#not_available_captcha').hide();
                $('#not_available_default').show();
            }
        }
    }

    isAvailable(callback, eventName) {
        if (typeof(window.isEmailAvailableCache[this._getCacheKey()]) !== 'undefined') {
            callback(window.isEmailAvailableCache[this._getCacheKey()]);
            console.log('email check: isAvailable skipped as result already cached');
            return;
        }

        //for personal signup check in login directly for better performance (can be done via euapi if needed also):
        if (this.type === 'personal') {
            const username = this.email.split('@')[0];
            const postParams = { username: username };
            window.debounceIsFetching = true;
            window.debounceCounter = window.debounceCounter+1;

            if (window.debounceCache[postParams.username]) {
                // console.debug(postParams.username+' in ajax cache!');
                this._processResponse(callback, window.debounceCache[postParams.username], eventName);
                return;
            }

            $.ajaxSetup({
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                }
            });
            $.post(euPortalConfig.login_base_uri+'signup/check_username', postParams, (data) => {
                this._processResponse(callback, data, eventName);
                //do not add in cache if captcha is required first
                if (data.errorCode !== 'NO_STRONG_CAPTCHA') {
                    window.debounceCache[postParams.username] = data;
                }
            }, "json");
        } else {
            $.ajax({
                url: euPortalConfig.euapi_base_uri+'emails/'+this.type,
                type: 'get',
                data: {'email': this.email},
                statusCode: {
                    404: () => {
                        window.isEmailAvailableCache[this._getCacheKey()] = true;
                        console.log('email check: email not found so available');

                        callback(true); // email not found so available
                    },
                    200: () => {
                        window.isEmailAvailableCache[this._getCacheKey()] = false;

                        callback(false); // email already used
                    },
                    422: () => {

                        //do not save in cache as on captcha success event we retry the same e-mail but with valid captcha
                        // window.isEmailAvailableCache[this._getCacheKey()] = false;
                        callback(false); // validation error
                    },
                }
            });
        }
    }

    isValid () {
        if (!this.email) {
            return false;
        }

        const emailRegex = /^(?:[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
        console.log('email check: email regex check: '+emailRegex.test(punycode.toASCII(this.email)));

        return emailRegex.test(punycode.toASCII(this.email));
    }
}

export default EmailCheck;
